export function handleAccordion() {
    const acc: NodeListOf<HTMLElement> = document.querySelectorAll('.accordion-three');
    if (!acc) return;

    acc.forEach((item) => {
        openInfoContainer(item);
    });
}

function openInfoContainer(acc: HTMLElement) {
    const btns: NodeListOf<HTMLButtonElement> = acc.querySelectorAll('.accordion-three__accordion-btn');

    btns.forEach((btn) => {
        btn.addEventListener('click', function() {
            this.classList.toggle('accordion-three__accordion-btn--active');
            this.classList.contains('accordion-three__accordion-btn--active') ? this.setAttribute('aria-label', 'Hide content')  : this.setAttribute('aria-label', 'Show content')
        });
    });
}